import type { TimelineEntry } from "@/lib/activityTimeline/types";

/** Org timeline rows navigate only to lead / intake deep links (safe in-app routes). */
export function activityTimelineRowIsClickable(entry: TimelineEntry): boolean {
  if (!entry.deep_link) return false;
  const link = entry.deep_link.trim();
  return link.startsWith("/leads") || link.includes("sales-intake");
}
